import ReactSplitPane from './SplitPane';
import Pane from './Pane';
/**
 * Implementation from https://github.com/JeremyGrieshop/react-split-pane/blob/main/SplitPane.js
 */
export default ReactSplitPane;
export { Pane };